import { useContext } from 'react'
import { KeyCloakContext } from './KeyCloakProvider'
import { IKeyCloakHook } from './types'

const useKeycloakFeatures = (): IKeyCloakHook => {
  const { contextState, doLogout, doLogin } = useContext(KeyCloakContext)

  return {
    keyCloakUser: contextState?.keyCloakUser,
    doLogout,
    doLogin, 
    isLoging: contextState?.isLoging,
    isKeycloakInit: contextState?.isKeycloakInit,
    isAuthenticated: contextState?.isAuthenticated
  }
}

export default useKeycloakFeatures